import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { pageKeywords, pagePaths } from '../../../../constants/Page';
import { ExpenseDetailParams } from './ExpenseDetail';

/**
 * 経費詳細画面リダイレクト
 * @returns
 */
const ExpenseDetailRedirect: React.FunctionComponent = () => {
  const params = useParams<ExpenseDetailParams>();

  return (
    <Navigate
      replace
      to={`${pagePaths.EXPENSE_DETAIL}/${params.expenseId}/${pageKeywords.mode.VIEW}`}
    />
  );
};

export default ExpenseDetailRedirect;
